import { Box } from "@chakra-ui/react";

const AdminLastOrderScreen = () => {
    return ( 
        <Box>Order</Box>
     );
}
 
export default AdminLastOrderScreen;